<script setup lang="ts">
defineProps<{
  id?: string
  title?: string
}>()
</script>

<template>
  <svg
    id="a27a2f79-86c0-467a-985b-c14087d37ac8" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 272.91 54.56"
  >
    <defs>
      <linearGradient
        id="f6d26d21-dbcc-4cc6-a3c6-bb63f52d5d8d" x1="242.27" y1="16.18" x2="250.64" y2="51.29"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" />
        <stop offset="0.14" stop-color="#121111" />
        <stop offset="0.32" stop-color="#1f1d1d" />
        <stop offset="0.55" stop-color="#272525" />
        <stop offset="0.98" stop-color="#292727" />
      </linearGradient>
      <linearGradient
        id="b2cc3b17-19f7-4d7f-bfbf-9885dfe04f97" x1="24.05" y1="28.27" x2="38.23" y2="55.15"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15" />
        <stop offset="0.25" stop-color="#0a0a0a" />
        <stop offset="0.45" stop-color="#1c1a1a" />
        <stop offset="0.68" stop-color="#262424" />
        <stop offset="0.96" stop-color="#292727" />
      </linearGradient>
      <linearGradient
        id="a5a3febd-0bb8-40e1-a1a5-30e8a5b61c66" x1="73.23" y1="10.9" x2="73.23" y2="57.59"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" />
        <stop offset="0.14" stop-color="#121111" />
        <stop offset="0.31" stop-color="#1f1d1d" />
        <stop offset="0.53" stop-color="#272525" />
        <stop offset="0.96" stop-color="#292727" />
      </linearGradient>
      <linearGradient
        id="b23f80e3-d1e2-48bd-9ffc-68941bedf55e" x1="119.54" y1="10.9" x2="119.54" y2="57.59"
        xlink:href="#a5a3febd-0bb8-40e1-a1a5-30e8a5b61c66"
      />
      <linearGradient
        id="b07ac381-1122-489b-8c30-eee25b99fcf7" x1="160.64" y1="48.17" x2="185.4" y2="48.17"
        xlink:href="#f6d26d21-dbcc-4cc6-a3c6-bb63f52d5d8d"
      />
    </defs>
    <path
      d="M272.91,25.06c0,15.07-14.3,28.76-29.72,28.76s-26.6-10.51-26.6-25.57a24.66,24.66,0,0,1,.31-3.84C219.11,10.9,232.62-.74,246.72-.74,262.14-.74,272.91,10,272.91,25.06ZM246.2,10.5c-6.36,0-12.83,5.55-14.11,14.79-1.4,10.1,4,16.55,10.31,17.27,5.92.68,15.24-5.74,15.1-17.18C257.39,16,252.56,10.5,246.2,10.5Z"
      transform="translate(0 0.74)" fill="url(#f6d26d21-dbcc-4cc6-a3c6-bb63f52d5d8d)"
    />
    <polygon
      points="28.03 53.82 45.6 53.82 32.87 26.98 15.21 26.98 28.03 53.82"
      fill="url(#b2cc3b17-19f7-4d7f-bfbf-9885dfe04f97)"
    />
    <path
      d="M33.88,0C42.22,0,49,7.33,49,16.37c0,8.25-5.72,15.23-13,16.37a68.78,68.78,0,0,1-8,1c-3.07.23-7.33.17-11.08.18l-1.68,19.2H0L4.76,0ZM28.44,22.9c2.73,0,5.29-3.12,5.29-6.31a5.2,5.2,0,0,0-5.29-5.24H19L17.81,22.9Z"
      transform="translate(0 0.74)" fill="#292727"
    />
    <polygon points="58.35 0.73 96.25 0.73 95.29 12.08 57.59 12.08 58.35 0.73" fill="#292727" />
    <polygon
      points="57.59 12.08 53.77 53.82 91.69 53.82 92.68 42.55 69.73 42.55 70.61 32.95 85.58 32.95 86.7 21.71 71.61 21.71 72.49 12.08 57.59 12.08"
      fill="url(#a5a3febd-0bb8-40e1-a1a5-30e8a5b61c66)"
    />
    <polygon points="104.66 0.73 142.56 0.73 141.6 12.08 103.9 12.08 104.66 0.73" fill="#292727" />
    <polygon
      points="103.9 12.08 100.08 53.82 138 53.82 138.99 42.55 116.05 42.55 116.92 32.95 131.89 32.95 133.01 21.71 117.92 21.71 118.8 12.08 103.9 12.08"
      fill="url(#b23f80e3-d1e2-48bd-9ffc-68941bedf55e)"
    />
    <polygon
      points="161.44 53.82 184.34 53.82 185.4 42.52 160.64 42.52 160.64 53.82 161.44 53.82"
      fill="url(#b07ac381-1122-489b-8c30-eee25b99fcf7)"
    />
    <polygon points="151.21 0.73 146.35 53.82 161.44 53.82 166.14 0.73 151.21 0.73" fill="#292727" />
    <polygon points="195.97 0.73 191.12 53.82 206.21 53.82 210.91 0.73 195.97 0.73" fill="#292727" />
    <path
      d="M243.19,53.82c15.42,0,29.72-13.69,29.72-28.76S262.14-.74,246.72-.74c-14.1,0-27.61,11.64-29.82,25.15,0,0,7.39-19.21,27.85-13.91l-.31.16a11.52,11.52,0,0,1,1.76-.16c6.36,0,11.19,5.48,11.3,14.88.14,11.44-9.18,17.86-15.1,17.18"
      transform="translate(0 0.74)" fill="#292727"
    />
    <path d="M216.9,24.41" transform="translate(0 0.74)" fill="#292727" />
  </svg>
</template>
